import ValuationStepValidator from '@/interfaces/valuation/ValuationStepValidator'
import {
  ValuationStepData,
  UnitValuationStepData,
} from '@/interfaces/valuation/ValuationData'
import { Message, MessageType } from '@/interfaces/app/Message'
import createMessage from '@/services/app/createMessage'
import {
  ApartmentUnit,
  HouseUnit,
} from '@/interfaces/valuation/types/UnitValuationStep'

export default class UnitValuationStepValidator extends ValuationStepValidator {
  public validate = (data: ValuationStepData): Message[] => {
    const stepData = data as UnitValuationStepData
    const unit: ApartmentUnit | HouseUnit = stepData.unit
    const errors: Message[] = []

    if (
      unit.hasOwnProperty('apartmentNumber') &&
      !(unit as ApartmentUnit).apartmentNumber &&
      !(unit as ApartmentUnit).apartmentBusinessDesignation
    ) {
      errors.push(
        createMessage('Krok 4 - Nevyplněné číslo bytu', MessageType.Error)
      )
    }

    if (
      unit.hasOwnProperty('apartmentNumber') &&
      !(unit as ApartmentUnit).apartmentArea
    ) {
      errors.push(
        createMessage('Krok 4 - Nevyplněná plocha jednotky', MessageType.Error)
      )
    }

    if (
      unit.hasOwnProperty('houseNumber') &&
      !(unit as HouseUnit).houseNumber
    ) {
      errors.push(
        createMessage('Krok 4 - Nevyplněné číslo popisné', MessageType.Error)
      )
    }

    if (
      unit.hasOwnProperty('houseNumber') &&
      !(unit as HouseUnit).houseUsableArea
    ) {
      errors.push(
        createMessage(
          'Krok 4 - Nevyplněná užitná plocha domu',
          MessageType.Error
        )
      )
    }

    if (
      unit.hasOwnProperty('houseNumber') &&
      !(unit as HouseUnit).houseBuiltArea
    ) {
      errors.push(
        createMessage(
          'Krok 4 - Nevyplněná zastavěná plocha domu',
          MessageType.Error
        )
      )
    }

    if (
      unit.hasOwnProperty('houseNumber') &&
      !(unit as HouseUnit).housePlotArea
    ) {
      errors.push(
        createMessage('Krok 4 - Nevyplněná plocha pozemku', MessageType.Error)
      )
    }

    if (
      unit.hasOwnProperty('houseNumber') &&
      !(unit as HouseUnit).houseFloors
    ) {
      errors.push(
        createMessage('Krok 4 - Nevyplněný počet podlaží', MessageType.Error)
      )
    }

    if (errors.length === 0) {
      this.isValid = true
      return [createMessage('Krok 4 je vyplněný správně', MessageType.Success)]
    } else {
      this.isValid = false
      return errors
    }
  }
}
